import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const WidgetBell: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        style={customStyle}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M15 17H9m6 0a3 3 0 01-6 0m6 0h2a1 1 0 001-1l-1.5-3V9a5.5 5.5 0 00-11 0v4L4 16a1 1 0 001 1h2" />
      </svg>
    </div>
  );
};

export default WidgetBell;
